import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicFourierHalfRange = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="FOURIER HALF RANGE SINE AND COSINE SERIES"
      videos={[
        "https://www.youtube.com/embed/Ry45T8VROCg?list=PLhSp9OSVmeyLke5_cby8i8ZhK8FHpw3qs",
        "https://www.youtube.com/embed/4zl91OUlxOI?list=PLhSp9OSVmeyLke5_cby8i8ZhK8FHpw3qs",
        "https://www.youtube.com/embed/zaPGRX3s9fk?list=PLhSp9OSVmeyLke5_cby8i8ZhK8FHpw3qs"
      ]}
      takeaways={[]}
      questions={[]}
      exampleVideos={[]}
    />
);
}

export default ModuleSubtopicFourierHalfRange;